export class Api {
    static getUrl(path: string): string {
        return `${process.env.REACT_APP_API_URL ?? 'https://api.raporty.termmed.pl'}/api${path}`;
    }
}
